import { getLanguageFromExtranetCookie } from './getLanguageFromExtranetCookie';
import { getLanguageFromi18Next } from './getLanguageFromi18Next';

export function getLanguage(): string {
  let language = getLanguageFromi18Next();
  if (language !== null) return language;
  language = getLanguageFromExtranetCookie();
  if (language !== null) return language;
  return 'fr';
}
